import { render } from "./LayoutSelection.vue?vue&type=template&id=5d094620&scoped=true"
import script from "./LayoutSelection.vue?vue&type=script&lang=js"
export * from "./LayoutSelection.vue?vue&type=script&lang=js"

import "./LayoutSelection.vue?vue&type=style&index=0&id=5d094620&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d094620"]])

export default __exports__